export const fmt = {
    date: (d) => (d ? new Date(d).toLocaleDateString() : "—"),
    money: (n) => (n === 0 || n ? `€${Number(n).toFixed(2)}` : "—"),
    text: (t) => (t && String(t).trim().length ? t : "—"),
};
